import { ExternalLink } from '../../Clickables/ExternalLink/ExternalLink';
import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';
import { NextImageWrapper } from '../../NextImage/NextImageWrapper';
import { twMerge } from 'tailwind-merge';

interface IProps {
  className?: string;
  title: string;
  description: string | undefined;
  email: string | undefined;
  logo: string | undefined;
  phoneNumber: string | undefined;
  website: string | undefined;
  buttonLink: string | undefined;
  buttonText: string | undefined;
  imageH: number | undefined;
  imageW: number | undefined;
}

export const AgencyItem = ({
  className,
  title,
  description,
  email,
  logo,
  phoneNumber,
  website,
  buttonLink,
  buttonText,
  imageH,
  imageW,
}: IProps) => {
  const ASPECTWIDTH = imageW ?? 200;
  const ASPECTHEIGHT = imageH ?? 200;

  return (
    <div
      className={twMerge(
        'bg-tuna-tint my-8 flex w-full flex-col rounded-lg px-4 py-6 sm:flex-row sm:px-8',
        className,
      )}
      data-testid="AgencyItem"
    >
      <div className="mb-4 flex sm:mb-0">
        {logo && (
          <div className="w-col-1 sm:w-col-3 md:w-col-2 relative h-full">
            <NextImageWrapper
              alt={title}
              src={logo}
              customLoader={{
                customLoaderType: 'contentful',
                origWidth: ASPECTWIDTH,
                origHeight: ASPECTHEIGHT,
              }}
              height={imageH}
              width={imageW}
              imageClassName="h-full object-contain"
            />
          </div>
        )}
        <Heading as="h3" variant="sm" className="w-col-3 ml-4 sm:hidden">
          {title}
        </Heading>
      </div>

      <div className="sm:w-col-9 md:w-col-10 flex flex-col gap-4 sm:ml-4 sm:gap-6 md:ml-8">
        <div>
          <Heading as="h3" variant="sm" className="hidden sm:block">
            {title}
          </Heading>
          <Text>{description}</Text>
          <div className="flex flex-col gap-4">
            <Text className="m-0 font-semibold">Phone: {phoneNumber}</Text>
            {email && (
              <ExternalLink href={`mailto:${email}`} className="font-semibold" target="blank">
                Email: {email}
              </ExternalLink>
            )}
            {website && (
              <ExternalLink href={website} target="blank">
                Visit website
              </ExternalLink>
            )}
          </div>
        </div>
        {buttonLink && buttonText && (
          <ExternalLink
            variant="buttonPrimary"
            href={buttonLink}
            className="w-full sm:w-max"
            target="blank"
          >
            {buttonText}
          </ExternalLink>
        )}
      </div>
    </div>
  );
};
